import { render, staticRenderFns } from "./Lesson12.vue?vue&type=template&id=3c2b0f45&scoped=true&"
import script from "./Lesson12.vue?vue&type=script&lang=js&"
export * from "./Lesson12.vue?vue&type=script&lang=js&"
import style0 from "./Lesson12.vue?vue&type=style&index=0&id=3c2b0f45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2b0f45",
  null
  
)

export default component.exports